import { render, staticRenderFns } from "./PostingBosReport.vue?vue&type=template&id=ca2a958a"
import script from "./PostingBosReport.vue?vue&type=script&lang=js"
export * from "./PostingBosReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports